var _path, _path2, _path3, _path4, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenNaira(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0466 23.2939C6.11663 23.2939 1.29663 18.4739 1.29663 12.5439C1.29663 6.61395 6.11663 1.79395 12.0466 1.79395C12.4566 1.79395 12.7966 2.13395 12.7966 2.54395C12.7966 2.95395 12.4566 3.29395 12.0466 3.29395C6.94663 3.29395 2.79663 7.44395 2.79663 12.5439C2.79663 17.6439 6.94663 21.7939 12.0466 21.7939C17.1466 21.7939 21.2966 17.6439 21.2966 12.5439C21.2966 12.1339 21.6366 11.7939 22.0466 11.7939C22.4566 11.7939 22.7966 12.1339 22.7966 12.5439C22.7966 18.4739 17.9766 23.2939 12.0466 23.2939Z",
    fill: "#318C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0466 8.29395H17.0466C16.6366 8.29395 16.2966 7.95395 16.2966 7.54395V3.54395C16.2966 3.13395 16.6366 2.79395 17.0466 2.79395C17.4566 2.79395 17.7966 3.13395 17.7966 3.54395V6.79395H21.0466C21.4566 6.79395 21.7966 7.13395 21.7966 7.54395C21.7966 7.95395 21.4566 8.29395 21.0466 8.29395Z",
    fill: "#318C64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0466 8.2934C16.8566 8.2934 16.6666 8.2234 16.5166 8.0734C16.2266 7.7834 16.2266 7.3034 16.5166 7.0134L21.5166 2.0134C21.8066 1.7234 22.2866 1.7234 22.5766 2.0134C22.8666 2.3034 22.8666 2.7834 22.5766 3.0734L17.5766 8.0734C17.4266 8.2234 17.2366 8.2934 17.0466 8.2934Z",
    fill: "#318C64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82724 16.5439V8.843H9.99338L13.8549 14.6407V8.843H15.021V16.5439H13.8549L9.99338 10.7462V16.5439H8.82724Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.04614,
    y1: 11.2939,
    x2: 16.0471,
    y2: 11.2939,
    stroke: "black",
    strokeWidth: 1.00012
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.04614,
    y1: 13.2939,
    x2: 16.0471,
    y2: 13.2939,
    stroke: "black",
    strokeWidth: 1.00012
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenNaira);
export default __webpack_public_path__ + "static/media/green-naira.a8873d24cc6e30a3148de102bb9c9268.svg";
export { ForwardRef as ReactComponent };